import React, { useState } from 'react';

import { fetchWeather } from './api/fetchWeather';

import './App.css';

const App = () => {

    const [query, setQuery] = useState('');
    const [weather, setWeather] = useState({});
    
    const search = async (e) => {
        if(e.key === 'Enter') {
            const response = await fetchWeather(query);

            setWeather(response);
            setQuery('');

            // console.log(response);
        }
    }

    return (
        <div className='main-container'>
            <input
            type='text'
            className='search'
            placeholder='Search...'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={search}
            />
            {weather.main && (
                <div className='weather'>
                    <div className='city-name'>
                        <span>{weather.name}</span>
                       <sup>{weather.sys.country}</sup>
                    </div>
                    <div className='city-temp'>
                        <span>{Math.round(weather.main.temp)}</span>
                        <span><sup>&deg;C</sup></span>
                    </div>
                    <div className='info'>
                        <img className='city-icon' src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}  alt={weather.weather[0].description} />
                        <p>{weather.weather[0].description}</p>
                    </div>
                </div>
            )}
         </div>
    );
};

export default App;